<template>
  <div class="home">
    <h5 style="color: #ffffff">  请输入正确链接地址</h5>
<!--    <img alt="Vue logo" src="../assets/logo.png">-->
<!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',

}
</script>
